exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th{text-align:center}.checkbox-toolbar{align-items:flex-start}.feat-checkbox{width:31%;min-height:118px;font-weight:400}.feat-checkbox b{font-weight:700;font-size:18px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-114c1564","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SelectFeat.vue
// module id = 83
// module chunks = 0